<li class="list-item btn {{stateClass}}">
    <h3>{{item.text}}</h3>
</li>
